<!--
  ~ /**
  ~   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~   ~  * No part of this publication may be reproduced, distributed,
  ~   ~  * or transmitted in any form or by any means, including photocopying, recording,
  ~   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~   ~  * except in the case of brief quotations embodied in critical
  ~   ~  * reviews and certain other noncommercial uses permitted by copyright law.
  ~   ~  * AUTHOR : bs
  ~   ~  * DATE : 15/05/2025 13:50
  ~ **/
  -->

<div class="wrapper">
  @if (label()) {
    <div class="label">
      {{ label() }}
    </div>
  }
  <div class="wrapper-drawing" [style.height.px]="height()">
    @if (showDeleteButton()) {
      <div class="actions">
        <div class="action" (click)="onClickDelete($event)">
          <i class="fal fa-trash-alt"></i>
        </div>
      </div>
    }
    @if (defaultSignature()) {
      <div class="default-value-overlay" (touchstart)="onClickDelete($event)">
        <img src="{{ defaultSignature() }}" />
      </div>
    }
    <infl-drawing
      [height]="height()"
      [color]="color()"
      [headerDisplayed]="false"
      [fullScreen]="false"
      (historyChange)="onHistoryChange($event)"
    />
  </div>
</div>

<infm-dialog
  [title]="'Effacer'"
  [actions]="dialogActions()"
  (actionClick)="onActionClickDialog($event)"
>
  Êtes vous sur de vouloir effacer la signature ?
</infm-dialog>
